import Ajax from './Ajax';

const analyticsRequest = async (url: string, params = {}) => {
  try {
    await Ajax.get(url, { params });
  } catch (e) {
    // Analytics requests can fail quietly.
  }
};

export const viewProduct = (productId: number) => {
  analyticsRequest(`a/view_product/${productId}`);
};

export const getGaId = (): Promise<string | undefined> => {
  const getCookieValue = (name) =>
    document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';

  const gaCookie = getCookieValue('_ga');
  if (gaCookie) {
    return Promise.resolve(gaCookie.substring(6));
  }
  return Promise.resolve(undefined);
};
